import React from 'react';
import { Calendar, Repeat, PlaneTakeoff } from 'lucide-react';
import SlideOver from './SlideOver';

/**
 * "+ Add Availability" chooser. Three options — Recurring / Additional / Apply Leave.
 * Clicking a card fires the corresponding callback and closes the slide-over.
 */
export default function AddAvailabilitySlideOver({
  open,
  onClose,
  onRecurring,
  onAdditional,
  onLeave,
}) {
  const options = [
    {
      key: 'recurring',
      icon: Repeat,
      title: 'Recurring Availability',
      body: 'Set weekly slots that repeat every week (e.g. every Monday 4–6 PM).',
      gradient: 'from-violet-100 to-indigo-100',
      iconColor: 'text-violet-600 bg-violet-100',
      onClick: () => { onClose?.(); onRecurring?.(); },
      testid: 'availability-option-recurring',
    },
    {
      key: 'additional',
      icon: Calendar,
      title: 'Additional Availability',
      body: 'Add extra one-time slots on top of your recurring schedule.',
      gradient: 'from-amber-100 to-orange-100',
      iconColor: 'text-amber-700 bg-amber-100',
      onClick: () => { onClose?.(); onAdditional?.(); },
      testid: 'availability-option-additional',
    },
    {
      key: 'leave',
      icon: PlaneTakeoff,
      title: 'Apply Leave',
      body: 'Block a date or a range so no bookings can be made.',
      gradient: 'from-rose-100 to-pink-100',
      iconColor: 'text-rose-700 bg-rose-100',
      onClick: () => { onClose?.(); onLeave?.(); },
      testid: 'availability-option-leave',
    },
  ];

  return (
    <SlideOver
      open={open}
      onClose={onClose}
      title="Add Availability"
      subtitle="Choose how you want to open your calendar."
      dataTestid="add-availability-slideover"
    >
      <div className="flex flex-col gap-3">
        {options.map(o => {
          const Icon = o.icon;
          return (
            <button
              key={o.key}
              onClick={o.onClick}
              data-testid={o.testid}
              className={`text-left group flex items-start gap-4 p-4 rounded-2xl bg-gradient-to-br ${o.gradient} border border-white/60 hover:shadow-lg hover:-translate-y-0.5 transition-all`}
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${o.iconColor} flex-shrink-0`}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <p className="font-extrabold text-slate-900 text-base">{o.title}</p>
                <p className="text-sm text-slate-600 mt-1">{o.body}</p>
              </div>
              <span className="text-slate-400 group-hover:text-slate-900 group-hover:translate-x-1 transition-all font-bold text-lg">›</span>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-slate-400 mt-6 text-center">Tip: Recurring slots power your default week — use Additional for one-off tutoring, and Leave to block time off entirely.</p>
    </SlideOver>
  );
}
